/* ═══════════════════════════════════════════════════
   DWL — hoogte van de header doorgeven aan de panelen

   Het open zoekpaneel en het hamburgermenu moeten precies onder de
   header beginnen en doorlopen tot de onderkant van het scherm. Die
   bovengrens is geen vast getal: hij verschilt per toestel en verandert
   zodra de lopende tekstbalk wegscrolt en de header vastplakt.

   Daarom meten we hem en zetten we 'm als CSS-variabele:
     --dwl-header-bottom  onderkant van de header
     --dwl-panel-top      onderkant van de zoekbalk als die openstaat,
                          anders gelijk aan de header
   ════════════════════════════════════════════════════ */
(function () {

  function measure() {
    var header = document.querySelector('.shopify-header-section');
    if (!header) return;

    var hb = Math.round(header.getBoundingClientRect().bottom);
    if (hb < 0) hb = 0;
    document.documentElement.style.setProperty('--dwl-header-bottom', hb + 'px');

    /* Staat de zoekbalk open, dan begint het paneel onder die balk. */
    var top = hb;
    var root = document.querySelector('.section-header-right .search-dropdown');
    if (root) {
      var open = root.classList.contains('active') || root.contains(document.activeElement);
      var form = root.querySelector('form');
      if (open && form) {
        var fb = Math.round(form.getBoundingClientRect().bottom);
        if (fb > top) top = fb + 10;
      }
    }
    document.documentElement.style.setProperty('--dwl-panel-top', top + 'px');
  }

  function boot() {
    measure();

    window.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('orientationchange', measure);
    window.addEventListener('load', measure);

    document.addEventListener('focusin', measure);
    document.addEventListener('focusout', function () { setTimeout(measure, 50); });
    document.addEventListener('click', function () { setTimeout(measure, 60); }, true);

    /* De header verandert van hoogte zodra hij vastplakt. */
    var root = document.querySelector('.section-header-right .search-dropdown');
    if (root && window.MutationObserver) {
      new MutationObserver(measure).observe(root, { attributes: true, attributeFilter: ['class'] });
    }

    document.addEventListener('shopify:section:load', measure);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
